import { styleConstants } from '@paywithextend/components'
import React from 'react'
import AccountVerificationBlocked from 'src/assets/images/AccountVerificationBlocked.svg'
import AppName from 'src/components/AppName/AppName'
import Box from 'src/components/Box/Box'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

type AccountVerificationBlockedBoxProps = {
  secondParagraph: React.ReactNode
}

const AccountVerificationBlockedBox = (
  props: AccountVerificationBlockedBoxProps,
): React.ReactElement => {
  const { secondParagraph } = props

  return (
    <Box
      css={css`
        align-items: center;
        align-self: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 500px;
      `}
    >
      <img
        src={AccountVerificationBlocked}
        alt=""
        css={css`
          max-width: 106px;
        `}
      />
      <div
        css={css`
          display: flex;
          align-items: center;
          margin-top: 10px;
          color: ${styleConstants.colors.red};
        `}
      >
        <h3>
          <Trns source={'Verification blocked'} />
        </h3>
      </div>
      <p
        css={css`
          margin-top: 20px;
        `}
      >
        <Trns
          source={
            'For security purposes, the verification of this ${appName} account has been blocked.'
          }
          expressions={{
            appName: <AppName />,
          }}
        />
      </p>
      <p
        css={css`
          margin-top: 20px;
        `}
      >
        {secondParagraph}
      </p>
    </Box>
  )
}

export default AccountVerificationBlockedBox
